'use strict';

import { find, findAll, register } from '../../../../JavaScript/Utils';

const Main = $el => {
    const $mainNav = $el;
    const $header = find('[data-component="Header"]');
    const $menuCloseBtns = findAll('[data-nezzo-btn-main-menu-close]', $mainNav);
    const $menuItems = findAll('.sub[data-component="Level1"]', $mainNav);
    const $level2Items = findAll('.nav__main-sub-2--item', $mainNav);
    const classMainNavOpen = 'main-nav-open';
    const classHeader = 'nav-open';

    const closeSubMenus = () => {
        $menuItems.forEach($item => {
            $item.classList.remove(classMainNavOpen);
        });
        $header.classList.remove(classHeader);
    };

  // Function to open the menu tree to the active link
  function openActiveMenuTree() {
  
    // Find the active link marked with 'data-nezzo-menu-current'
    const activeLink = document.querySelector('.nav__main-sub-3--item .active');
    if (!activeLink) {
      return;
    }
  
    let currentElement = activeLink;
    let i = 0;
    // Traverse up to the main menu list to open all parent submenus
    while (currentElement && !currentElement.matches('.nav__mobile-main--list')) {
      if (currentElement.classList.contains('nav__main-sub-2--item')) {

        let siblingElement = currentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
        // Open this submenu if it's not already open
        if (!currentElement.classList.contains('opened')) {

          currentElement.classList.add('opened');
        //   currentElement.style.maxHeight = currentElement.scrollHeight + 'px';

          // Add style to all parent submenus
          siblingElement.classList.add('sub-item-open');

          // Add last_clicked style to the last parent element
        //   if (i < 1){
        //     let childElement = siblingElement.getElementsByTagName('span')[0];
        //     childElement.classList.add('last_clicked');
        //     i++;
        //   }
        }
      }
      // Move to the next parent element
      currentElement = currentElement.parentElement;
    }
  
  }  

    const closeLevel3Menus = () => {
        const $level3Menus = findAll('.nav__main-item--sub-3', $mainNav);
        const $arrow_icon = findAll('.nav__main-arrow-icon', $mainNav);
        const $a = findAll('a.nav__main-sub-2--item-title');
        $level3Menus.forEach($menu => {
            $menu.style.display = 'none';
        });
        $arrow_icon.forEach($icon => {
            $icon.style.display = 'none';
        });
        $a.forEach($link => {
            $link.classList.remove('hover');
        })
    };

    $menuCloseBtns.forEach($item => {
        $item.addEventListener('click', () => {
            closeSubMenus();
            closeLevel3Menus();
        });
    });

    $menuItems.forEach($item => {
        const $element = find('.nav__main--item-link', $item);
        $element.addEventListener('mouseover', () => {
            closeSubMenus();
            closeLevel3Menus();
            $item.classList.add(classMainNavOpen);
            $header.classList.add(classHeader);
        });
    });

    $mainNav.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget || !event.relatedTarget.closest('.header__col--nav-main')) {
            closeSubMenus();
            closeLevel3Menus();
        }
    });

    $level2Items.forEach($item => {
        const $a = find('a.nav__main-sub-2--item-title', $item);
        if ($a) {
            $a.addEventListener('mouseover', () => {
                closeLevel3Menus();
                const $level3Menu = find('.nav__main-item--sub-3', $item);
                const $arrow_icon = find('.nav__main-arrow-icon', $item);
                if ($level3Menu) {
                    $a.classList.add('hover');
                    $level3Menu.style.display = 'block';
                    if ($arrow_icon) {
                        $arrow_icon.style.display = 'block';
                    }
                }
            });
        }
    });
    openActiveMenuTree();

};
register('Main', Main);
